import Chip from '@mui/material/Chip';
import ListItem from '@mui/material/ListItem';
import { darken } from '@mui/material/styles';
import { ReactNode } from 'react';

export interface ListSectionItemProps {
  value?: string;
  variant: 'primary' | 'secondary' | 'warning';
  children: ReactNode;
}
export const ListSectionItem = ({ value, variant, children }: ListSectionItemProps) => {
  const getVariant = (variant: string): 'filled' | 'outlined' => {
    if (variant === 'primary') {
      return 'filled';
    }
    return 'outlined';
  };

  const getColour = (variant: string): 'default' | 'primary' | 'warning' => {
    if (variant === 'primary') {
      return 'default';
    } else if (variant === 'warning') {
      return 'warning';
    }
    return 'primary';
  };

  return (
    <ListItem
      sx={(theme) => ({
        '&.MuiListItem-root:hover': {
          background: darken(theme.palette.background.default, 0.03),
        },
        border: '1px solid',
        borderColor: theme.palette.divider,
        borderRadius: theme.spacing(1),
        mb: 1,
      })}
      secondaryAction={
        value ? <Chip variant={getVariant(variant)} size="small" color={getColour(variant)} label={value} /> : null
      }
    >
      {children}
    </ListItem>
  );
};
